import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { State } from 'src/app/shared/models/State';
import { Address } from 'src/app/shared/models/Address';
import { Participant } from 'src/app/shared/models/Participant';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { WSAttendance } from 'src/app/shared/models/WSAttendance';
import { WSParticipantVO } from 'src/app/shared/models/WSParticipantVO';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { DatePipe } from '@angular/common';
import { ChurchAdressVO } from 'src/app/shared/models/ChurchAdressVO';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';

@Component({
  selector: 'app-shoolfpg-participant-detail',
  templateUrl: './shoolfpg-participant-detail.component.html',
  styleUrls: ['./shoolfpg-participant-detail.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ShoolfpgParticipantDetailComponent implements OnInit {

  /** SECURITY */
  dataParent: any;
  security: SecurityDocument;

  /**REDIRECT */
  participant: any;
  schoolfpg: any;


  /** INPUTS */
  listLanguage: ValuesVO[];
  selectedLanguage: ValuesVO;
  address: Address;
  identID: string;
  currJob: string;
  idDocum: string;
  namePart: string;
  lastNamePart: string;
  sencondLastNamePart: string;
  email: string;
  city: string;
  neight: string;
  occupation: string;
  age: number;
  guideSatus: string;
  guideType: string;
  cellPhone: string;
  homeNumber: string;
  zipcode: string;
  street: string;
  birthday: string;
  currDate: String;

  listGender: CategoryLan[];
  selectedGender: CategoryLan;
  listMarrStat: CategoryLan[];
  selectedMarrStat: CategoryLan;

  listState: State[];
  selectedState: State;
  churchAddress: ChurchAdressVO;

  /** GENERAL */
  date1: Date;
  cities: any[];
  value1: number;
  disabled: boolean;

  /** DATE RANGES */
  maxDate: Date = new Date();
  isOutOfRange: boolean = false;
  fgChangesLog: { id: { key1Id: string; currDate: string; sequen: string; fileId: string; }; comments: string; }[];

  /** LABELS */
  translations: Record<string, string> = {};

  // translations.lbl_go_Back: string = "back_";
  // translations.lbl_personal_information: string = "personal_information_";
  // translations.lbl_name: string = "name_";
  // translations.lbl_last_name: string = "last_name_";
  // translations.lbl_language: string = "language_";
  // translations.lbl_email: string = "email_";
  // translations.lbl_birth_Date: string = "birth_Date_";
  // translations.lbl_age: string = "age_";
  // translations.lbl_gender: string = "gender_";
  // translations.lbl_cell_phone: string = "cell_phone_";
  // translations.lbl_home_phone: string = "home_phone_";
  // translations.lbl_address: string = "address_";
  // translations.lbl_state: string = "state_";
  // translations.lbl_county_city: string = "county_city_";
  // translations.lbl_neightborhood: string = "neightborhood_";
  // translations.lbl_street_and_number: string = "street_and_number_";
  // translations.lbl_zip_code: string = "zip_code_";
  // translations.lbl_save: string = "save_";
  // translations.lbl_delete: string = "delete_record_";
  // translations.lbl_select: string = "select_";
  // translations.lbl_church_name: string = "church_name_";
  // translations.lbl_workshop: string = "workshop_";
  // translations.lbl_schedule: string = "schedule_";
  // translations.lbl_are_you_sure = "are_you_sure_";
  // translations.lbl_update = "update_";
  // translations.lbl_confirm = "confirm_";
  // translations.lbl_delete_record_ = "delete_record_";
  // translations.lbl_yes: string = "yes_";
  // translations.lbl_no: string = "no_";
  // translations.lbl_school_prep_guides: string = "school_prep_guides_";
  // translations.lbl_issued_identity: string = "issued_identity_";
  // translations.lbl_current_job: string = "current_job_";
  // translations.lbl_marriage_status: string = "marriage_status_";
  // translations.lbl_history: string = "history_";
  // translations.lbl_leaving_reason: string = "leaving_reason_";
  // translations.lbl_status: string = "status_";
  // translations.lbl_record: string = "record_";
  // translations.lbl_record_not_valid : string = "record_not_valid_";
  // translations.lbl_message : string = "message_";
  // translations.lbl_record_already_exists : string = "record_already_exists_";
  // translations.lbl_there_is_not: string = "there_is_not_";
  // translations.lbl_change : string = "change_";
  // translations.lbl_id : string = "id_";
  // translations.lbl_guide: string = "guide_";
  // translations.lbl_participants : string = "participants_";


  /**
   * This is a constructor function that initializes various services and variables, and retrieves data
   * from the previous navigation state.
   * @param {MessageService} messageService - A service for displaying messages to the user.
   * @param {ConfirmationService} confirmationService - A service that provides methods to display
   * confirmation dialogs to the user.
   * @param {ApiService} apiService - An instance of the ApiService class, which is likely used to make
   * HTTP requests to an API or backend server.
   * @param {Router} router - The router is a service provided by Angular that allows navigation between
   * different components and views in a single-page application. It provides methods for navigating to
   * different routes and accessing information about the current route. In this constructor, the router
   * is injected as a dependency and used to retrieve data passed through navigation extras.
   * @param {TovpilUtilsService} tovpilUtils - TovpilUtilsService is a service that provides utility
   * functions for the TOVPIL application. It is likely used to perform common tasks such as formatting
   * data or handling errors.
   * @param {DatePipe} datePipe - The `DatePipe` is a built-in Angular pipe that is used to format dates
   * in a specific way. It takes a date object as input and returns a formatted string based on the
   * specified format. It is commonly used in Angular applications to display dates in a user-friendly
   * format.
   */
  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private tovpilUtils: TovpilUtilsService,
    private translationService: TovpilLanguageService,
    private datePipe: DatePipe
  ) {
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;

    if (this.dataParent) {
      this.security = this.dataParent.security;
      this.participant = this.dataParent.participant;
      this.schoolfpg = this.dataParent.eppg;

      if (this.participant) {
        this.getCreateUpdateCancelSchoolEnrollFG(this.getSchoolEnrollFGWrpVO('GET'));
      } else {
      }
      this.findChurchAdressById(this.schoolfpg.schoolFPG.churchId);
    } else {
      this.redirectParticipant();
    }
  }

  async getCreateUpdateCancelSchoolEnrollFG(req: any) {
    try {
      const data = await this.apiService.getCreateUpdateCancelSchoolEnrollFG(req);
      if (req.method === 'GET') {
        this.participant = data.guideAddr;
      }
    } catch (error) {
    }
  }

  async getTranslatedLabels() {
    try {
      await this.translationService.getTranslatedLabels(this.security.language, this.security.region);
      this.translations = this.translationService.getLabels();
      await this.getLanguages();
      // this.getLstCols();;
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
      // Error al traer labels traducidos
    }
  }

  getSchoolEnrollFGWrpVO(option: string) {
    let guideId = {
      guideId: this.participant.guide.guideId || null,
    };
    let guide = {
      guide: guideId || null,
    };

    let req = {
      schoolId: this.schoolfpg.schoolFPG.schoolId || null,
      guideAddr: guide,
      method: option
    };

    return req;
  }

  /**
   * The ngOnInit function calls several methods to retrieve translated labels, states by country,
   * gender, and languages.
   */
  ngOnInit(): void {
    this.getTranslatedLabels();
    this.getGender();
    this.getLanguages();
    this.getmMarrStat();
  }

  /**
   * This function redirects the user to the workshopsParticipant page with workshop and security
   * information passed as navigation extras.
   */
  redirectParticipant() {
    let obj = {
      eppg: this.schoolfpg,
      security: this.security
    }

    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }
    this.router.navigate(['catalogs/eppgs/schoolfpgParticipant'], navigationExtras);
  }

  /**
   * The function loads participant details and assigns them to corresponding variables.
   */
  loadDataDetail() {
    if (this.participant != null) {
      this.namePart = this.participant.guide.name;
      this.lastNamePart = this.participant.guide.lastName;
      this.identID = this.participant.guide.identID;
      this.currJob = this.participant.guide.currJob;
      this.email = this.participant.guide.email;
      this.cellPhone = this.participant.guide.mobPhon;
      this.age = +this.participant.guide.age;
      this.guideSatus = this.participant.guide.status;
      this.guideType = this.participant.guide.guiType;
      this.currDate = this.participant.guide.currDate;
      this.getAddressParticipant(this.participant.address);
      this.birthday = this.datePipe.transform(new Date(this.tovpilUtils.convertStringToDate(
        this.participant.guide.birYear.toString() +
        this.participant.guide.birMont.toString() +
        this.participant.guide.birDay.toString()).toISOString()), "dd/MM/yyyy");
      this.calculateAge();
      this.loadStatusChangesFG(this.participant, true);
    }
  }

  /**
 * The function `loadStatusChangesFG()` loads the historical changes for a specific school and
 * language.
 */
  loadStatusChangesFG(data: any, opt: boolean) {
    let params = {
      fileId: "Guides",
      key1Id: opt ? data.guide.guideId : data.guideAddr.guide.guideId
    }

    //params.key1Id = "0017656";

    this.apiService.getListFgHistorialChanges(params).then(
      changes => {
        this.fgChangesLog = changes;
      });
  }


  /**
   * The function `convertDateFormat` takes a string in the format "YYYYMMDD" and returns a string in the
   * format "DD-MM-YYYY".
   * @param {string} originalDateStr - The originalDateStr parameter is a string representing a date in
   * the format "YYYYMMDD".
   * @returns a string in the format "day-month-year".
   */
  convertDateFormat(originalDateStr: string): string {
    const year = originalDateStr.substr(0, 4);
    const month = originalDateStr.substr(4, 2);
    const day = originalDateStr.substr(6, 2);

    return `${day}-${month}-${year}`;
  }

  /**
   * This function retrieves a list of languages from an API and sets the selected language based on the
   * participant's first language or defaults to the first language in the list.
   */
  getLanguages() {
    const body = {
      storeId: this.schoolfpg.schoolFPG.storeId,
      language: this.security.language
    }
    this.apiService.getListSpkLangByStoreId(body).then(
      data => {
        this.listLanguage = data;
        if (this.participant) {
          this.selectedLanguage = this.listLanguage.find(l => l.valueId === this.participant.guide.firstLang);
        }
        if (!this.selectedLanguage) {
          this.selectedLanguage = this.listLanguage[0];
        }
      });
  }

  /**
   * This function retrieves a list of gender categories and selects the gender of a participant if it is
   * provided.
   */
  getGender() {
    const body = {
      fieldId: "sex",
      language: this.security.language
    }
    this.apiService.getCategoryLang(body).then(
      data => {
        this.listGender = data;
        if (this.participant) {
          this.selectedGender = this.listGender.find(l => l.fieldVal === this.participant.guide.gender);
        }
      });
  }
  getmMarrStat() {
    const body = {
      fieldId: "marStat",
      language: this.security.language
    }
    this.apiService.getCategoryLang(body).then(
      data => {
        this.listMarrStat = data;
        if (this.participant) {
          this.selectedMarrStat = this.listMarrStat.find(l => l.fieldVal === this.participant.guide.marrStat);
        }
      });
  }

  /**
   * This function retrieves a list of states based on the selected country and assigns it to a variable,
   * then performs additional actions based on whether a participant is present or not.
   */
  // TODO: VERIFICAR COUNTRY 
  getStatesByCountry(country: string) {
    this.apiService.getStatesByCountry(country).then(
      data => {
        this.listState = data;
        if (this.participant) {
          this.loadDataDetail();
        } else {
          this.selectedState = this.listState.find(l => l.id.stateId == this.churchAddress.state);
        }
      });
  }

  /**
   * This function retrieves an address participant by ID and assigns its properties to corresponding
   * variables.
   * @param {string} addrId - The parameter `addrId` is a string that represents the ID of an address.
   * This function uses the `apiService` to retrieve the address information associated with the given
   * `addrId`. Once the address information is retrieved, it sets various properties such as `city`,
   * `neight`, `selected
   */
  getAddressParticipant(address: any) {
    this.apiService.getAdressById({ addrId: address.addrId }).then(
      addr => {
        this.address = addr;
        this.city = this.address.city;
        this.neight = this.address.neight;
        this.selectedState = this.listState.find(l => l.id.stateId == this.address.state);
        this.street = this.address.street;
        this.zipcode = this.address.zipCode;
        this.homeNumber = this.address.tel1;

      })
  }

  /**
   * This function calculates the age of a person based on their birthday.
   */
  calculateAge() {
    if (this.birthday) {

      const dateParts = this.birthday.split('/');
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1; // Adjust month value since it starts from 0
      const year = parseInt(dateParts[2], 10);
      const tmpDate = new Date(year, month, day);
      let today = new Date();

      let years = today.getFullYear() - tmpDate.getFullYear();

      if (
        today.getMonth() < tmpDate.getMonth() ||
        (today.getMonth() === tmpDate.getMonth() &&
          today.getDate() < tmpDate.getDate())
      ) {
        years--;
      }

      if (years <= 0) {
        years++;
      }

      if (years <= 0) {
        this.messageService.add({ severity: 'error', summary: 'Crear Participante', detail: "Error Fecha Nacimiento", life: 3000 });
      }

      this.age = years;
    }
  }

  /**
   * The function checks if the age is out of range (less than 18 or greater than 100) and sets a boolean
   * flag accordingly.
   */
  checkRange() {
    if (this.age < 18 || this.age > 100) {
      this.isOutOfRange = true;
    } else {
      this.isOutOfRange = false;
    }
  }

  /**
   * This function validates if the age and birthday fields are valid based on certain conditions.
   * @returns A boolean value indicating whether the age and birthday fields are valid.
   */
  validateAgeField(): boolean {
    const birthdayRegex = /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/(\d{4})$/;
    const ageValid = this.age >= 5 && this.age <= 100;
    const birthdayValid = birthdayRegex.test(this.birthday);

    return ageValid && birthdayValid;
  }


  /**
   * The function saves a participant if their age field is valid, otherwise it displays an error
   * message.
   */
  saveSchoolFg() {
    if (!this.validateAgeField()) {
      this.messageService.add({ severity: 'error', summary: 'Crear Participante', detail: "Fecha Nacimiento Invalida", life: 3000 });
    } else {
      this.confirmationService.confirm({
        message: this.translations.lbl_are_you_sure + " " + this.translations.lbl_update + "?",
        header: this.translations.lbl_confirm + " " + this.translations.lbl_update,
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.translations.lbl_yes,
        rejectLabel: this.translations.lbl_no,
        acceptButtonStyleClass: "p-button-success",
        rejectButtonStyleClass: "p-button-info",
        accept: () => {
          this.createUpdateDeleteSchoolFG('');
        }
      });
    }
  }

  /**
 * This function displays a confirmation dialog and deletes a participant if the user accepts the
 * confirmation.
 */
  deleteSchoolFG() {
    this.confirmationService.confirm({
      message: this.translations.lbl_are_you_sure + " " + this.translations.lbl_delete_record_ + "?",
      header: this.translations.lbl_confirm + " " + this.translations.lbl_delete_record_,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.createUpdateDeleteSchoolFG('D');
      }
    });
  }

  displayModalParticipantExists: boolean = false;
  participantExists: any;
  formattedDateExists: string;
  formattedAddressExists: string;
  formattedGenderExists: string;
  formattedReason: string;
  formattedStatus: string;

  formatParticipantValueExists() {
    const { birDay, birMont, birYear, gender } = this.participantExists.guideAddr.guide;
    const { city, country, state, street, neight } = this.participantExists.guideAddr.address;

    this.formattedReason = this.participantExists?.errorMessage ? this.participantExists.errorMessage.split('//')[0].trim() : '';
    this.formattedStatus = this.participantExists?.status === 'RECORDEXIST' ? this.translations['lbl_record_already_exists'] : this.translations['lbl_there_is_not'] + ' ' + this.translations['lbl_record'];

    this.formattedAddressExists = `${street},${neight} - ${city},${state}.${country}`
    this.formattedGenderExists = gender == 'F' ? 'Femenino' : 'Masculino';
    this.formattedDateExists = `${birDay}/${birMont}/${birYear}`;
  }

  closeModalParticipant() {
    this.displayModalParticipantExists = false;
  }

  closeModalParticipantExists() {
    // PARTICIPANTES
    this.participant = {}
    this.participant = this.participantExists.guideAddr;

    this.address = this.participant.address;
    this.guideType = this.participant.guide.guiType
    this.displayModalParticipantExists = false;
    this.participantExists = null;
    this.formattedDateExists = "";
    this.formattedAddressExists = "";
    this.formattedGenderExists = "";

    // SETTING ADDRESS
    this.currJob = this.participant?.guide?.currJob ?? " ";
    this.selectedMarrStat = this.listMarrStat.find(f => f.fieldVal === (this.participant?.guide?.marrStat ?? ""));
    this.email = this.participant?.guide?.email ?? " ";
    this.cellPhone = this.participant?.guide?.mobPhon ?? " ";
    this.homeNumber = this.participant?.guide?.mobPhon ?? " ";
    this.city = this.participant?.address?.city ?? " ";
    this.neight = this.participant?.address?.neight ?? " ";
    this.street = this.participant?.address?.street ?? " ";
    this.zipcode = this.participant?.address?.zipCode ?? " ";

    // SETTING STATUS TO RECOVER
    this.participant.guide.status = "A";
  }

  /**
 * This function creates a participant in a workshop and sends the participant's information to an API.
 */
  createUpdateDeleteSchoolFG(opt: string) {
    this.calculateAge();

    let [day, month, year] = this.birthday.split('/')
    const dateObj = new Date(+year, +month - 1, +day)

    let participantView = {
      guideId: this.participant != null ? this.participant.guide.guideId : "",
      name: this.namePart != null ? this.namePart : null,
      lastName: this.lastNamePart != null ? this.lastNamePart : null,
      identID: this.identID != null ? this.identID : null,
      currJob: this.currJob != null ? this.currJob : null,
      status: this.guideSatus != null ? this.guideSatus : "A",
      guiType: this.guideType != null ? this.guideType : "F",
      birYear: this.birthday != null ? year : null,
      birMont: this.birthday != null ? month : null,
      birDay: this.birthday != null ? day : null,
      currDate: this.currDate,
      gender: this.selectedGender != null ? this.selectedGender.fieldVal : null,
      marrStat: this.selectedMarrStat != null ? this.selectedMarrStat.fieldVal : null,
      privData: true,
      storeId: this.schoolfpg.schoolFPG != null ? this.schoolfpg.schoolFPG.storeId : this.security.storeId,
      firstLang: this.selectedLanguage != null ? this.selectedLanguage.valueId : null,
      email: this.email,
      mobPhon: this.cellPhone,
      address: this.address != null ? this.address.addrId : null,
      age: this.age != null ? this.age.toString() : "",
    }

    // TODO: VERIFICAR COUNTRY 
    let addressSend: Address = {
      addrId: this.address != null ? this.address.addrId : null,
      country: this.security.region,
      state: this.selectedState != null ? this.selectedState.id.stateId : null,
      personType: "G",
      city: this.city ? this.city : null,
      neight: this.neight ? this.neight : null,
      storeId: this.schoolfpg.schoolFPG.storeId,
      street: this.street,
      latitude: null,
      longitude: null,
      tel1: this.homeNumber,
      zipCode: this.zipcode
    }

    let guideAddr = {
      guide: participantView,
      address: addressSend,
    }

    let req = {
      schoolId: this.schoolfpg.schoolFPG.schoolId,
      guideAddr: guideAddr,
      language: this.security.language,
      method: opt == 'D' ? 'DELETE' : this.participant == null ? 'CREATE' : 'UPDATE',
    }

    this.apiService.getCreateUpdateCancelSchoolEnrollFG(req).then(
      data => {
        if (data.status == 'OK') {
          this.messageService.add({
            severity: 'success', summary: 'Crear Futuro Guía', detail: 'Se ' +
              req.method === 'DELETE' ? 'eliminó' : req.method === 'UPDATE' ? 'actualizó' : 'creo'
                + ' futuro guía correctamente', life: 3000
          });

          this.redirectParticipant();
        } else if (data && data.status.trim() == 'RECORDEXIST') {
          this.displayModalParticipantExists = true;
          this.participantExists = (data);

          this.formatParticipantValueExists();
          this.loadStatusChangesFG(data, false);

        } else {
          this.messageService.add({ severity: 'error', summary: 'Crear Futuro Guía', detail: data.errorMessage, life: 9000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Crear Futuro Guía', detail: error, life: 3000 });
      }).finally(() => {
      });
  }

  /**
   * The function retrieves translations for a list of labels and updates the corresponding variables
   * with the translated values.
   */
  // getTranslatedLabels() {
  //   let map = new Map();
  //   let lstRespTranslate: TranslateRelLabelVO[];
  //   this.apiService.listByLanguageMultFields({
  //     'language': this.security.language,
  //     'region': this.security.region,
  //     'lstLabels': [this.translations.lbl_id, this.translations.lbl_guide,this.translations.lbl_participants,this.translations.lbl_change,this.translations.lbl_there_is_not,this.translations.lbl_record_already_exists,this.translations.lbl_message,this.translations.lbl_record_not_valid,this.translations.lbl_record,this.translations.lbl_status,this.translations.lbl_leaving_reason,this.translations.lbl_history,this.translations.lbl_go_Back, this.translations.lbl_personal_information, this.translations.lbl_name, this.translations.lbl_last_name, this.translations.lbl_language, this.translations.lbl_email, this.translations.lbl_birth_Date, this.translations.lbl_age, this.translations.lbl_gender, this.translations.lbl_cell_phone, this.translations.lbl_home_phone, this.translations.lbl_address, this.translations.lbl_state, this.translations.lbl_county_city, this.translations.lbl_neightborhood, this.translations.lbl_street_and_number, this.translations.lbl_save, this.translations.lbl_delete, this.translations.lbl_select, this.translations.lbl_church_name, this.translations.lbl_workshop, this.translations.lbl_schedule, this.translations.lbl_zip_code, this.translations.lbl_are_you_sure, this.translations.lbl_update, this.translations.lbl_confirm, this.translations.lbl_delete_record_, this.translations.lbl_yes, this.translations.lbl_no, this.translations.lbl_school_prep_guides, this.translations.lbl_issued_identity, this.translations.lbl_current_job, this.translations.lbl_marriage_status]
  //   }).then(
  //     trDocs => {
  //       trDocs.forEach((element) => {
  //         map.set(element.labelId, element.translation);
  //       });
  //       this.translations.lbl_go_Back = map.get(this.translations.lbl_go_Back);
  //       this.translations.lbl_personal_information = map.get(this.translations.lbl_personal_information);
  //       this.translations.lbl_name = map.get(this.translations.lbl_name);
  //       this.translations.lbl_last_name = map.get(this.translations.lbl_last_name);
  //       this.translations.lbl_language = map.get(this.translations.lbl_language);
  //       this.translations.lbl_email = map.get(this.translations.lbl_email);
  //       this.translations.lbl_birth_Date = map.get(this.translations.lbl_birth_Date);
  //       this.translations.lbl_age = map.get(this.translations.lbl_age);
  //       this.translations.lbl_gender = map.get(this.translations.lbl_gender);
  //       this.translations.lbl_cell_phone = map.get(this.translations.lbl_cell_phone);
  //       this.translations.lbl_home_phone = map.get(this.translations.lbl_home_phone);
  //       this.translations.lbl_address = map.get(this.translations.lbl_address);
  //       this.translations.lbl_state = map.get(this.translations.lbl_state);
  //       this.translations.lbl_county_city = map.get(this.translations.lbl_county_city);
  //       this.translations.lbl_neightborhood = map.get(this.translations.lbl_neightborhood);
  //       this.translations.lbl_street_and_number = map.get(this.translations.lbl_street_and_number);
  //       this.translations.lbl_zip_code = map.get(this.translations.lbl_zip_code);
  //       this.translations.lbl_save = map.get(this.translations.lbl_save);
  //       this.translations.lbl_delete = map.get(this.translations.lbl_delete);
  //       this.translations.lbl_select = map.get(this.translations.lbl_select);
  //       this.translations.lbl_church_name = map.get(this.translations.lbl_church_name);
  //       this.translations.lbl_workshop = map.get(this.translations.lbl_workshop);
  //       this.translations.lbl_schedule = map.get(this.translations.lbl_schedule);
  //       this.translations.lbl_are_you_sure = map.get(this.translations.lbl_are_you_sure);
  //       this.translations.lbl_confirm = map.get(this.translations.lbl_confirm);
  //       this.translations.lbl_update = map.get(this.translations.lbl_update);
  //       this.translations.lbl_delete_record_ = map.get(this.translations.lbl_delete_record_);
  //       this.translations.lbl_yes = map.get(this.translations.lbl_yes);
  //       this.translations.lbl_no = map.get(this.translations.lbl_no);
  //       this.translations.lbl_school_prep_guides = map.get(this.translations.lbl_school_prep_guides);
  //       this.translations.lbl_issued_identity = map.get(this.translations.lbl_issued_identity);
  //       this.translations.lbl_current_job = map.get(this.translations.lbl_current_job);
  //       this.translations.lbl_marriage_status = map.get(this.translations.lbl_marriage_status);
  //       this.translations.lbl_change = map.get(this.translations.lbl_change);
  //       this.translations.lbl_there_is_not = map.get(this.translations.lbl_there_is_not);
  //       this.translations.lbl_record_already_exists = map.get(this.translations.lbl_record_already_exists);
  //       this.translations.lbl_message = map.get(this.translations.lbl_message);
  //       this.translations.lbl_record_not_valid = map.get(this.translations.lbl_record_not_valid);
  //       this.translations.lbl_record = map.get(this.translations.lbl_record);
  //       this.translations.lbl_status = map.get(this.translations.lbl_status);
  //       this.translations.lbl_leaving_reason = map.get(this.translations.lbl_leaving_reason);
  //       this.translations.lbl_history = map.get(this.translations.lbl_history);
  //       this.translations.lbl_participants = map.get(this.translations.lbl_participants);
  //       this.translations.lbl_id = map.get(this.translations.lbl_id);
  //       this.translations.lbl_guide  = map.get(this.translations.lbl_guide);
  //     });
  // }

  /**
   * The function "goBack()" closes the current window.
   */
  goBack() {
    window.close();
  }
  findChurchAdressById(churchId: string) {
    this.apiService.getChurchAdressById({
      "churchId": churchId
    }).then(
      data => {
        this.churchAddress = data;
        if (data) {
          this.getStatesByCountry(this.churchAddress.country);
        }
      });
  }
}
